/**
 * Created by Victor Rojo on 21/11/18.
 */
import { Injectable, Optional }     from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';

@Injectable()
export class ElementService{

  private basePath = "api/v1/element/";
  constructor(
    private http: HttpClient
  ) { }

  private errorHandler(error: any): Promise<any> {
    console.log('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  setElementValue(elementId:string, value:string): Promise<any>{
    let url = this.basePath + elementId + "/value";
    return this.http.put(url, value, { responseType: 'text' })
      .toPromise()
      .catch( error => this.errorHandler(error) );
  }

}
